import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ImageGallery.css';

const ImageGallery = ({ images, itemName }) => {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);

  if (!images || images.length === 0) {
    return (
      <div className="image-gallery-empty">
        <div className="no-image-placeholder">
          <span>📷</span>
          <p>{t('noImages') || 'No images'}</p>
        </div>
      </div>
    );
  }

  const primaryImage = images.find(img => img.is_primary) || images[0];
  const thumbnails = images.sort((a, b) => a.order - b.order);

  return (
    <div className="image-gallery">
      {/* Main Image */}
      <div className="gallery-main">
        <div className="main-image-container">
          <img
            src={primaryImage.thumbnail_url || primaryImage.image_url}
            alt={itemName}
            loading="lazy"
            className="main-image"
            onClick={() => setShowLightbox(true)}
            onError={(e) => {
              if (primaryImage.image_url && e.currentTarget.src !== primaryImage.image_url) {
                e.currentTarget.src = primaryImage.image_url;
              }
            }}
          />
          {primaryImage.is_primary && (
            <span className="primary-indicator">Primary</span>
          )}
        </div>
      </div>

      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="gallery-thumbnails">
          {thumbnails.map((image, index) => (
            <div
              key={image.id}
              className={`thumbnail ${index === selectedIndex ? 'active' : ''}`}
              onClick={() => {
                setSelectedIndex(index);
              }}
            >
              <img 
                src={image.thumbnail_url || image.image_url} 
                alt={`${itemName} ${index + 1}`}
                loading="lazy"
                onError={(e) => {
                  if (image.image_url && e.currentTarget.src !== image.image_url) {
                    e.currentTarget.src = image.image_url;
                  }
                }}
              />
            </div>
          ))}
        </div>
      )}

      {/* Lightbox */}
      {showLightbox && (
        <div 
          className="lightbox-overlay"
          onClick={() => setShowLightbox(false)}
        >
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="lightbox-close"
              onClick={() => setShowLightbox(false)}
            >
              ×
            </button>
            <img
              src={primaryImage.image_url}
              alt={itemName}
              className="lightbox-image"
            />
            <p className="image-counter">
              {selectedIndex + 1} / {images.length}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
